angular.module( 'acme.view.application.pos.create.pages.forms.page', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.pos.create.pages.forms.page.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var posCreatePagesFormsPage = {
        name: 'application.pos.create.pages.forms.page',
        url: '/page',
        views: {
          "subview-main": {
            controller: 'PosCreatePagesFormsPageController',
            // Assumes the view is entirely self contained
            templateUrl: 'views/application/views/pos/create/pages/forms/page/page.tpl.html'
          }
        },
        data: {
          pageTitle: '     ',
          /** Secure With Permissions **/
          permissions: []
        }
      };

    $stateProvider
      .state(posCreatePagesFormsPage);
});
